import { API_ENDPOINTS } from "../constants";
import { showDevelopmentError } from "src/utils";
import axios from "src/services/axios";

export const getTrendAlerts = async (
  authorId?: string,
  trackerId?: string,
): Promise<TrendAlert.Data[]> => {
  try {
    const response = await axios.post(API_ENDPOINTS.getTrendAlerts, {
      authorId,
      trackerId,
    });
    const result: TrendAlert.Data[] = response.data;
    return result;
  } catch (error) {
    showDevelopmentError({
      error,
      additionalTexts: ["TREND ALERTS ERROR"],
    });
    return [];
  }
};

export const createTrendAlert = async (
  payload: TrendAlert.CreationData,
): Promise<TrendAlert.Data | null> => {
  try {
    const response = await axios.post(API_ENDPOINTS.createTrendAlert, payload);
    const result: TrendAlert.Data = response.data;
    return result;
  } catch (error) {
    showDevelopmentError({
      error,
      additionalTexts: ["TREND ALERTS ERROR"],
    });
    return null;
  }
};

export const updateTrendAlert = async (
  payload: TrendAlert.CreationData,
): Promise<TrendAlert.Data | null> => {
  try {
    const { id, ...updatePayload } = payload;
    const response = await axios.patch(
      `${API_ENDPOINTS.updateTrendAlert}/${id}`,
      updatePayload,
    );
    const result: TrendAlert.Data = response.data;
    return result;
  } catch (error) {
    showDevelopmentError({
      error,
      additionalTexts: ["TREND ALERTS ERROR"],
    });
    return null;
  }
};

export const deleteTrendAlert = async (
  id: TrendAlert.Data["id"],
): Promise<void> => {
  try {
    await axios.delete(`${API_ENDPOINTS.deleteTrendAlert}/${id}`);
  } catch (error) {
    showDevelopmentError({
      error,
      additionalTexts: ["TREND ALERTS ERROR"],
    });
  }
};

export const getCurrentVolume = async (trackerId: string): Promise<number> => {
  try {
    const response = await axios.post(API_ENDPOINTS.getCurrentVolume, {
      trackerId,
    });
    const result: number = response.data.volume;
    return result;
  } catch (error) {
    showDevelopmentError({
      error,
      additionalTexts: ["CURRENT VOLUME ERROR"],
    });
    return 0;
  }
};
